import { RequestSuccess } from '@/services/knows/conversation';
import { userActivityConsume } from '@/services/user';
import { UserActivity } from '@/services/user/typings';
import { Modal, message } from 'antd';
import React from 'react';
import { unwrapResponse } from './request';

const showSevenDaysTrialActivity = (activities: UserActivity[]) => {
  const sevenDay = activities.find(
    (item) => item.activity_id === 'seven-days-trial-activity',
  );
  if (sevenDay) {
    Modal.info({
      title: '',
      content: '',
      okText: '立即领取',
      maskClosable: false,
      closable: true,
      centered: true,
      width: 'fit-content',
      height: 'fit-content',
      icon: null,
      cancelButtonProps: {
        style: {
          display: 'none',
        },
      },
      okButtonProps: {
        style: {
          width: '100%',
          height: 48,
          borderRadius: 16,
          color: '#fff',
          fontSize: 16,
          fontFamily: 'MiSans',
          fontWeight: 630,
        },
      },
      styles: {
        content: {
          padding: 12,
          width: 314,
          height: 293,
          paddingTop: 212,
          backgroundColor: '#fff',
          borderRadius: 20,
          background: `linear-gradient(180deg, #FCEEFF 0%, #E3F3FF 54.43%), #F1F6F9`,
          backgroundImage: `url('https://nullht-official-website.oss-cn-shanghai.aliyuncs.com/KNOWS_DOCTOR/ACTIVITY_IMAGES/aiagent/20250808-14500.png')`,
          backgroundSize: '100% 100%',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        },
      },

      onOk: async () => {
        try {
          await unwrapResponse(
            userActivityConsume('seven-days-trial-activity'),
            {
              success: (res) => {
                if (res.code === RequestSuccess) {
                  window.location.reload();
                }
              },
              fail: (res) => {
                message.error(res?.msg || '领取失败');
                // window.location.reload();
              },
            },
          );
        } catch (e) {}
      },
    });
  }
};

const showThreeDaysTrialActivity = (activities: UserActivity[]) => {
  const sevenDay = activities.find(
    (item) => item.activity_id === 'three-days-trial-activity',
  );
  const isShowed = sessionStorage.getItem('knows_activity_popup_showed');
  const currentPage = window.location.pathname;
  const homePage = localStorage.getItem('third_home_page');
  const isHomePage = currentPage === homePage;
  if (
    !isShowed &&
    sevenDay &&
    !sevenDay.expired &&
    sevenDay.custom_fields?.is_popup &&
    sevenDay?.custom_fields?.popup_image &&
    isHomePage
  ) {
    sessionStorage.setItem('knows_activity_popup_showed', 'true');
    Modal.info({
      title: '',
      content: React.createElement('div', {
        style: {
          width: 314 * 1.4,
          height: 293 * 1.4,
          cursor: 'pointer',
        },
        onClick: (e) => {
          window.open(
            'https://mp.weixin.qq.com/s/HFvmVHQeWYbB5eefnvTMzQ',
            '_blank',
          );
        },
      }),
      maskClosable: false,
      closable: true,
      centered: true,
      width: 'fit-content',
      height: 'fit-content',
      icon: null,
      footer: null,
      contentProps: {
        onClick: (e) => {
          console.log('click');
        },
      },

      cancelButtonProps: {
        style: {
          display: 'none',
        },
      },

      styles: {
        content: {
          padding: 12,
          width: 314 * 1.5,
          height: 293 * 1.5,
          borderRadius: 16,
          backgroundImage: `url(${sevenDay?.custom_fields?.popup_image})`,
          backgroundSize: '100% 100%',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        },
      },
    });
  }
};

const showKanghongActivity = (activities: UserActivity[]) => {
  const trialCard = activities.find(
    (item) => item.activity_id === 'teacher-tang-talks-recommendation-activity',
  );

  const isShowed = sessionStorage.getItem('kanghong_activity_showed');
  const currentPage = window.location.pathname;
  const homePage = localStorage.getItem('third_home_page');
  const isHomePage = currentPage === homePage;
  if (
    !isShowed &&
    trialCard &&
    !trialCard.expired &&
    trialCard.custom_fields?.is_popup &&
    trialCard?.custom_fields?.popup_image &&
    isHomePage
  ) {
    sessionStorage.setItem('kanghong_activity_showed', 'true');
    Modal.info({
      title: '',
      content: '',
      maskClosable: true,
      closable: true,
      centered: true,
      width: 'fit-content',
      height: 'fit-content',
      icon: null,
      footer: null,
      cancelButtonProps: {
        style: {
          display: 'none',
        },
      },

      styles: {
        content: {
          padding: 12,
          width: 341,
          height: 600,
          borderRadius: 16,
          backgroundImage: `url(${trialCard?.custom_fields?.popup_image})`,
          backgroundSize: '100% 100%',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        },
      },
    });
  }
};

export {
  showKanghongActivity,
  showSevenDaysTrialActivity,
  showThreeDaysTrialActivity,
};
